import { render, staticRenderFns } from "./MilestoneTaskCard.vue?vue&type=template&id=22468825"
import script from "./MilestoneTaskCard.vue?vue&type=script&lang=js"
export * from "./MilestoneTaskCard.vue?vue&type=script&lang=js"
import style0 from "./MilestoneTaskCard.vue?vue&type=style&index=0&id=22468825&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports